import { useState } from 'react'
import { useLoadScript } from '@react-google-maps/api'

export const useGoogleMapsLoader = () => {
  const [libraries] = useState<'places'[]>(['places'])

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY,
    libraries,
  })

  return { isLoaded }
}
